import React from 'react';
import { useQuery } from 'urql';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import { visitorId, setCartItemsCount } from '../features/cart/cartSlice';
import { get } from 'lodash';

const CartItemsQuery = `
query CartItems($visitorId: String!)  {
  cartItems (visitor_id: $visitorId)  {
      category_id
      category_name
      category {
          id
          name
          slug
      }
      items {
          id
          visitor_id
          product_id
          variant_id
          qty
          product {
              id
              name
              slug
              main_image_url
              price
              final_price
          }
          variant {
              id
              name
              sku
              price
              final_price
          }
      }
      children {
          category_id
          category_name
          items {
              id
              visitor_id
              product_id
              variant_id
              qty
              product {
                  id
                  name
                  slug
                  main_image_url
                  price
                  final_price
              }
              variant {
                  id
                  name
                  sku
                  price
                  final_price
              }
          }
          children {
              category_id
              category_name
              items {
                  id
                  visitor_id
                  product_id
                  variant_id
                  qty
                  product {
                      id
                      name
                      slug
                      main_image_url
                      price
                      final_price
                  }
                  variant {
                      id
                      name
                      sku
                      price
                      final_price
                  }
              }
          }
      }
  }
  }
`;

export const useCartRefetch = () => {
  const dispatch = useAppDispatch();
  const currentVisitorId = useAppSelector(visitorId);
  
  // Sử dụng useQuery với pause để có thể reexecute khi cần
  const [result, reexecuteQuery] = useQuery({
    query: CartItemsQuery,
    variables: { visitorId: currentVisitorId || '' },
    pause: true, // Không tự động query, chỉ query khi gọi reexecuteQuery
    requestPolicy: 'network-only'
  });

  const refetchCart = async () => {
    if (!currentVisitorId) return;
    
    // Reexecute query với network-only để force refetch và update cache
    // result.data sẽ được cập nhật tự động qua useQuery hook
    try {
      reexecuteQuery({ 
        requestPolicy: 'network-only',
        variables: { visitorId: currentVisitorId }
      });
    } catch (error) {
      console.error('Error refetching cart:', error);
    }
  };

  // Update cart count khi result.data thay đổi (nếu query được execute)
  React.useEffect(() => {
    if (result.data && result.data.cartItems && currentVisitorId) {
      const count = get(result.data, 'cartItems', []).length;
      dispatch(setCartItemsCount(count));
    } else if (result.data && (!result.data.cartItems || result.data.cartItems.length === 0) && currentVisitorId) {
      // Cập nhật count về 0 nếu giỏ hàng trống
      dispatch(setCartItemsCount(0));
    }
  }, [result.data, currentVisitorId, dispatch]);

  return { refetchCart };
};

